import { API_BASE_URL, AUTH_URL } from '@/environment'
import {
  getActiveSession,
  initializeSession,
  removeSession,
} from '@attensi/session'
import { redirectToLogin } from './loginActions'
import { customFetch } from './v3/apiV3Utils'

const activeSession = setupActiveSession()

async function setupActiveSession() {
  await initializeSession({
    authUrl: AUTH_URL,
    checkPathForSubdomain: true,
    checkParamsForAccessToken: false,
  })

  return getActiveSession()
}

export async function getAccessToken() {
  const session = await activeSession
  return session?.access_token
}

export async function getSubdomain() {
  const session = await activeSession
  return session?.subdomain
}

export async function getCompanyNameKey() {
  const session = await activeSession
  return session?.company_name_key
}

export async function revalidateActiveSession() {
  const session = await getActiveSession()

  if (session) {
    try {
      await accessTokenToTransferKey(session.access_token)
    } catch (error: unknown) {
      if ((error as { status: number }).status === 401) {
        await redirectToLogin()
      }
    }
  }
}

// To be used for shared device timeouts, simple redirect is not enough for slo companies
export async function revokeActiveSession() {
  const session = await activeSession
  if (session) {
    await revokeAccessToken(session.access_token)
    await removeSession(session.subdomain)
  }
}

const revokeAccessToken = async (accessToken: string) => {
  await customFetch(`${API_BASE_URL}/api/v1/oauth/revoke`, {
    method: 'POST',
    body: JSON.stringify({
      token: accessToken,
      token_type_hint: 'access_token',
    }),
  })
}

const accessTokenToTransferKey = async (accessToken: string) => {
  const response = await customFetch(`${AUTH_URL}/api/v1/sessions/transfer`, {
    method: 'PUT',
  })

  if (!response.ok) {
    throw new Error(JSON.stringify({ ...response }))
  }

  return await response.json()
}
